import { createFileRoute, notFound } from '@tanstack/react-router';

import { AuthorPageView } from '@/components/site/pages';
import { buildAuthorProfileJsonLd } from '@/lib/author-json-ld';
import { seoHead } from '@/lib/seo';
import { loadAuthorPage } from '@/server/functions/pages';

export const Route = createFileRoute('/author/$id')({
    loader: async ({ params }) => {
        const data = await loadAuthorPage({ data: params.id });
        if (!data) throw notFound();
        return data;
    },
    head: ({ loaderData }) => {
        const author = loaderData?.author;
        if (!author) {
            return seoHead({
                title: 'כותב/ת לא נמצא/ה',
                description: 'פרופיל הכותב/ת לא נמצא.',
                path: '/',
                noIndex: true,
            });
        }

        const description =
            author.biography?.slice(0, 200)
            || `כל הכתבות של ${author.name} באשקלון ניוז - חדשות אשקלון מהשטח`;

        return seoHead({
            title: author.name,
            description,
            path: `/author/${encodeURIComponent(author.$id)}`,
            type: 'profile',
            image: author.profileUrl,
            jsonLd: buildAuthorProfileJsonLd(author, loaderData?.articles ?? []),
        });
    },
    component: AuthorPage,
});

function AuthorPage() {
    const data = Route.useLoaderData();
    return <AuthorPageView author={data.author} articles={data.articles} />;
}
